import { getAuthHeader, handleResponse, API_BASE_URL } from './api';

export const notifications = {
  getAll: async () => {
    try {
      const headers = await getAuthHeader('GET');
      const response = await fetch(`${API_BASE_URL}/notifications`, {
        headers,
        credentials: 'include'
      });
      return handleResponse(response);
    } catch (err) {
      console.error('Failed to fetch notifications:', err);
      throw err;
    }
  },

  getUnreadCount: async () => {
    try {
      const headers = await getAuthHeader('GET');
      const response = await fetch(`${API_BASE_URL}/notifications/unread-count`, {
        headers,
        credentials: 'include'
      });
      const data = await handleResponse(response);
      return data.count;
    } catch (err) {
      console.error('Failed to fetch unread count:', err);
      throw err;
    }
  },

  markAsRead: async (notificationIds) => {
    if (!Array.isArray(notificationIds) || notificationIds.length === 0) {
      throw new Error('notificationIds must be a non-empty array');
    }
    
    try {
      const headers = await getAuthHeader('POST');
      const response = await fetch(`${API_BASE_URL}/notifications/mark-read`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ notificationIds }),
        credentials: 'include'
      });
      
      const data = await handleResponse(response);
      
      if (!data.success || !Array.isArray(data.updatedIds)) {
        throw new Error('Invalid response from server');
      }
      
      return data;
    } catch (err) {
      console.error('Failed to mark notifications as read:', err);
      throw err;
    }
  },

  getPreferences: async () => {
    try {
      const headers = await getAuthHeader('GET');
      const response = await fetch(`${API_BASE_URL}/notifications/preferences`, {
        headers,
        credentials: 'include'
      });
      return handleResponse(response);
    } catch (err) {
      console.error('Failed to fetch notification preferences:', err);
      throw err;
    }
  },

  updatePreferences: async (preferences) => {
    try {
      const headers = await getAuthHeader('PUT');
      const response = await fetch(`${API_BASE_URL}/notifications/preferences`, {
        method: 'PUT',
        headers,
        body: JSON.stringify({ preferences }),
        credentials: 'include'
      });
      return handleResponse(response);
    } catch (err) {
      console.error('Failed to update notification preferences:', err);
      throw err;
    }
  },

  clearAll: async () => {
    try {
      const headers = await getAuthHeader('DELETE');
      const response = await fetch(`${API_BASE_URL}/notifications/clear-all`, {
        method: 'DELETE',
        headers,
        credentials: 'include'
      });
      return handleResponse(response);
    } catch (err) {
      console.error('Failed to clear all notifications:', err);
      throw err;
    }
  },

  delete: async (notificationId) => {
    try {
      const headers = await getAuthHeader('DELETE');
      const response = await fetch(`${API_BASE_URL}/notifications/${notificationId}`, {
        method: 'DELETE',
        headers,
        credentials: 'include'
      });
      return handleResponse(response);
    } catch (err) {
      console.error('Failed to delete notification:', err);
      throw err;
    }
  }
};
